<script setup lang="ts">
import type { LaptopMenuType } from '~/types/menu.type'
import ExIndicator from '~/ui/Indicator/ExIndicator.vue'

interface IProps {
  list: Array<LaptopMenuType>
}

defineProps<IProps>()

const activeClasses = 'bg-gradient-to-r from-explorer-blue/10 text-opacity-100 text-primary'
const highlightClasses = 'absolute w-1 bg-explorer-blue top-0 left-0 h-full rounded-r-lg'
</script>

<template>
  <aside class="py-8">
    <ul class="flex flex-col">
      <li
        v-for="menu in list"
        :key="menu.icon"
        class="py-3 pl-5 pr-2"
        :class="['relative text-xl', menu.isActive ? activeClasses : 'text-primary/40']"
      >
        <div
          v-if="menu.isActive"
          :class="highlightClasses"
        />
        <div class="relative box-content h-4 w-4 p-1 leading-none">
          <FontAwesomeIcon
            :icon="menu.icon"
            size="1x"
          />
          <ExIndicator
            v-if="menu.featured && menu.featured.length"
            class="absolute -right-2 -top-2"
          />
        </div>
      </li>
    </ul>
  </aside>
</template>

<style scoped>

</style>